/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import { Hidden } from '@material-ui/core';

import { useTranslation } from 'react-i18next';

// icon
import MapIcon from '@material-ui/icons/Map';
import VideocamOutlinedIcon from '@material-ui/icons/VideocamOutlined';
// style
// import { globalStyle } from '../../../global/style';
import { styles } from './style';
// import './styles.css';

import WaveDataLists from './WaveLists/WaveDataLists';
import WaveAnimationDataLists from './WaveLists/WaveAnimationDataLists';

const useStyles = makeStyles(styles);

function TabPanel(props) {
  const {
    children, value, index, ...other
  } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}
const TabContainer = ({ children }) => (
  <Box component="div">
    {children}
  </Box>
);

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

TabPanel.propTypes = {
  children: PropTypes.node.isRequired,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `forecast_wave_tab_${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function WaterLeveDatalists() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function List() {
    return (
      <>
        <Tabs value={value} onChange={handleChange} indicatorColor="primary" aria-label="simple tabs example">
          <Tab
            label={(
              <>
                <MapIcon />
                <Box ml={1}>
                  <Hidden only="xs">{t('แผนภาพคาดการณ์ความสูงและทิศทางคลื่นล่วงหน้า 7 วัน')}</Hidden>
                  <Hidden only="xl">{t('ล่วงหน้า 7 วัน')}</Hidden>
                </Box>
              </>
            )}
            {...a11yProps(0)}
            className={value === 0 ? classes.active_tab : classes.tab}
          />
          <Tab
            label={(
              <>
                <VideocamOutlinedIcon />
                <Box ml={1}>{t('ภาพเคลื่อนไหว')}</Box>
              </>
            )}
            {...a11yProps(1)}
            className={value === 1 ? classes.active_tab : classes.tab}
          />
        </Tabs>
        <Divider />
        <TabContainer component="div">
          <TabPanel value={value} index={0}>
            <WaveDataLists />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <WaveAnimationDataLists />
          </TabPanel>
        </TabContainer>
      </>
    );
  }

  return (
    <div className={classes.root}>
      <List />
    </div>
  );
}
